import { createContext } from 'react';

export interface IToggleButtonGroupContext {
  onGroupToggle?(on: boolean, value: string | number): void;
  isGroupOn?(value: string | number): boolean;
}

const ToggleButtonGroupContext = createContext<IToggleButtonGroupContext>({});
ToggleButtonGroupContext.displayName = 'ToggleButtonGroupContext.Provider';

export default ToggleButtonGroupContext;
